import { fromTable } from './functions.js';

export const PRIMARY_KEY = 'HISTOLITT_V2';

// Forbidden words must be written in accentless lowercase char
export const FORBIDDEN_WORDS = [];

const PTS_CARDINAUX = {
  NORD: 'NORD',
  NORD_EST: 'NORD_EST',
  EST: 'EST',
  SUD_EST: 'SUD_EST',
  SUD: 'SUD',
  SUD_OUEST: 'SUD_OUEST',
  OUEST: 'OUEST',
  NORD_OUEST: 'NORD_OUEST'
};

const TYPE_ILOT = {
  ARCHIPEL: 'ARCHIPEL',
  EN_LIEN_AVEC_LE_TRAIT_DE_COTE: 'EN_LIEN_AVEC_LE_TRAIT_DE_COTE',
  ILE_ISOLEE: 'ILE_ISOLEE',
  ESTUAIRE_OU_ESTRAN_OU_MER_INTERIERE: 'ESTUAIRE/ESTRAN/MER_INTERIERE'
};

const DB_TAXREF = {};
const BDC_STATUTS = {};
const EFF_NICHEURS = {};

export const ID_TEMPLATE = {
  ID: 'Number',
  HISTOLITT_V2: 'Number',  // <-- Primary Key
  HISTOLITT_V1: 'Number',
  CODE_HISTORIQUE: 'Number',
  CODE_BASILE: 'Number',
  CODE_GEOCA: 'Number',
  HELLO_WORLD: "Number",
  CODE_GISOM: 'Number',
  CODE_ENSEMBLE: 'Number',
  NOM_ENSEMBLE: 'String',
  CODE_ELEMENTAIRE: 'Number',
  NOM_ELEMENTAIRE: 'String',
};

// Key = Table as list, Value = inner Unique ID
export const TABLE_AS_LIST = {
  FAUNE: 'TAXREF',
}

export const CENSUS_TABLE = {
  OISEAUX_MARINS_NICHEURS: ['NOM_VERN', 'ANNEE', 'HISTOLITT_V2', ...Object.keys(ID_TEMPLATE)],
  AUTRES_SP_AVIF: ['NOM_VERN', 'ANNEE', 'HISTOLITT_V2', ...Object.keys(ID_TEMPLATE)],
  WETLAND: ['NOM_VERN', 'ANNEE', 'HISTOLITT_V2', ...Object.keys(ID_TEMPLATE)],
}

export const DATABASE = {
  ID: {
    ...ID_TEMPLATE
  },
  NOM_ILOTS: { // utiliser nom IGN + Nom 1 et 2 pour fiche ilot
    IGN: 'String', // majuscule sans accent
    NOM_SHOM: 'String',
    NOM_2: 'String',
    NOM_3: 'String',
  },
  STATUS: {
    RNN: 'Boolean', // ==> valable pour tous: remplissage oui, non en fonction des autes tables (SI ID HISTO V2 présente dans table N2000, RNN, RNR, alors oui)
    RNR: 'Boolean',
    APB: 'Boolean',
    RNCFS: 'Boolean',
    PNR: 'Boolean',
    PNMI: 'Boolean',
    ENS:'Boolean',
    ZPS: 'Boolean',  
    ZSC: 'Boolean',
    ZICO:'Boolean',
    RAMSAR: 'Boolean',
    SITE_CLASSE: 'Boolean',
    SITE_INSCRIT: 'Boolean',
    GRAND_SITE: 'Boolean',
    ZNIEFF_I: 'Boolean',
    ZNIEFF_II:'Boolean',
  },
  N_2000: {
    ZPS: 'String',
    CODE_ZPS: 'String',
    DATE_ZPS: 'String',
    ZSC: 'String',
    CODE_ZSC: 'String',
    DATE_ZSC: 'String',
    SIGNALETIQUE: 'Boolean',
    OPERATEUR_ZPS: 'String',
    OPERATEUR_ZSC: 'String',
  },
  RNN: {
    RNN: 'String',
    CODE_RNN: 'String',
    DATE: 'Date',
    SIGNALETIQUE: 'Boolean',
    GESTIONNAIRE: 'String',
  },
  RNR: {
    RNR: 'String',
    CODE_RNR: 'String',
    DATE: 'Date',
    SIGNALETIQUE: 'Boolean',
    GESTIONNAIRE: 'String',
  },
  RNCFS: {
    RNCFS: 'String',
    CODE_RNCFS: 'String',
    DATE: 'Date',
    SIGNALETIQUE: 'Boolean',
    GESTIONNAIRE: 'String',
  },
  PNR: {
    PNR: 'String',
    CODE_PNR: 'String',
    DATE: 'Date',
    SIGNALETIQUE: 'Boolean',
    GESTIONNAIRE: 'String',
  },
  PNM: {
    PNM: 'String',
    CODE_PNM: 'String',
    DATE: 'Date',
    SIGNALETIQUE: 'Boolean',
    GESTIONNAIRE: 'String',
  },
  ZNIEFF_I: {
    ZNIEFF_I: 'String',
    CODE_ZNIEFF: 'String',
    DATE: 'Date',
  },
  ZNIEFF_II: {
    ZNIEFF_II: 'String',
    CODE_ZNIEFF: 'String',
    DATE: 'Date'
  },
  ZICO: {
    ZICO: 'String',
    CODE_ZICO: 'String',
    DATE: 'Date'
  },
  APB: {
    APB: 'String',
    CODE_APB: 'String',
    DATE: 'Date',
    SIGNALETIQUE: 'Boolean',
    GESTIONNAIRE: 'String'
  },
  SITE_CLASSE_INSCRIT: {
    NOM_CLASSE:'String',
    CODE_CLASSE: 'String',
    NOM_INSCRIT:'String',
    CODE_INSCRIT: 'String',
    PDF: 'String'
  },
  GRAND_SITE: {
    NOM: 'String',
    DATE: 'Date',  
    GESTIONNAIRE: 'String'
  },
  RAMSAR: {
    RAMSAR: 'String',
    CODE_RAMSAR: 'String',
    DATE: 'Date',
    OPERAT: 'String'
  },
  STATUS_FONCIER: {
    DOMAINE: 'String',
    PROPRIETAIRES:  ['String'],  
    DATE: 'Date',
    GESTIONNAIRE: 'String', // 'String', 'String',... // <-- /!\ 5 mini colonnes 
    N_CADASTRE: 'Number',
    SURF_CADASTRE: 'Number',
    DEP: 'Number',
    COMMUNES: [ 'String', 'String', ],
  },
  CONVENTION_DE_GESTION: {
    CONV_VALID: 'Boolean',
    PERIODE_VALID: 'String',
    MEMBRES_CONV: 'String'
  },
  DESCRIPTION_GEO: {
    COORD_X: 'Number' ,
    COORD_Y: 'Number',
    ALTITUDE_MAX_SHOM: 'Number',
    SURFACE_HISTOLITT: 'Number',
    ORIENTATION: 'String',
    SURFACE_ESTRAN_ASSOCIEE: 'Number', 
    TYPE_ILOT: 'String',
    DISTANCE_COTE: 'Number',
    DIST_ILOT_PROCHE: 'Number',
    NOM_ILOT_PROCHE: 'String',
    RATTACH_ILOT_PRINCIPAL: 'String',
    APPARTENANCE_ARCHIPEL: 'Boolean',
    NOM_ARCHIPEL: 'String',
  },
  PATRIMOINE_NATUREL : {
    ETAT_DES_CONNAISSANCES: 'String',
    CONN_HAB: 'String',
    CONN_FLORE: 'String',
    CONN_REPT: 'String',
    CONN_AMPHI: 'String',
    CONN_AVIF: 'String',
    CONN_MAM: 'String',
    CONN_INVERT: 'String'
  },
  REF_TAXEREF_STATUT: {
    CD_REF: DB_TAXREF, // => COLONNE M  // Clef Primaire
    REGNE: DB_TAXREF, // => COLONNE A
    PHYLUM: DB_TAXREF, // => COLONNE B
    CLASSE: DB_TAXREF, // => COLONNE C
    ORDRE: DB_TAXREF, // => COLONNE D 
    FAMILLE: DB_TAXREF, // => COLONNE E
    NOM_SCI: DB_TAXREF, // => COLONNE S
    NOM_VERN: DB_TAXREF, // => COLONNE T
    URL: DB_TAXREF, // => COLONNE AN
    TYPE_STATUS: BDC_STATUTS, // => COLONNE E: Filtre: ‘liste rouge mondiale’ | ‘liste rouge européenne’ | ‘liste rouge nationale’ |‘liste rouge régionale’ : => LB_ADM_TR: Filtre: ‘Bretagne’|
  },
  EFF_NICHEURS: {
    CD_REF: 'Number',
    NOM_SCI: 'String',
    NOM_VERN: 'String',
    ANNEE: { ANNEE: 'Number' },
    R_D_NAT: 'String', // ← ex: [1535-1580]
    R_D_REG: 'String', // ← ex: [1535-1580]
    R_D_DEP: 'String', // ← ex: [1535-1580]
    EVOL_10: 'String', 
    EVOL_20: 'String',
    SOURCE: 'String'
  },
  EFF_HIVERNANTS: {
    CD_REF: 'Number',
    NOM_SCI: 'String',
    NOM_VERN: 'String',
    EFF_NAT: 'String',
    EFF_REG: 'String',
    EFF_DEP: 'String',
    SOURCE: 'String',
    EVOL_5: 'String',
    EVOL_10: 'String', 
    EVOL_15: 'String',
    EVOL_20: 'String',
  },
  IMAGES: {
    imgTopRight: 'String',
    imgBottomLeft: 'String',
    imgBottomRight: 'String'
  },
  OISEAUX_MARINS_NICHEURS: {
    CD_REF: 'Number',
    NOM_SCI: 'String',
    NOM_VERN: 'String',
    ANNEE: 'String', // fromTable(EFF_NICHEURS) ANNEE,
    R_D_MIN: 'String',
    R_D_MOY: 'String',
    R_D_MAX: 'String', // ← ex: [2005-2007]
    SOURCE: 'String',
    POURC_R_D_NAT: 'String', //FromTable(EFF_NICHEURS).R_D_NAT,
    POURC_R_D_REG: 'String', //FromTable(EFF_NICHEURS).R_D_REG,
    POURC_R_D_DEP: 'String', //FromTable(EFF_NICHEURS).R_D_DEP,
    AUTRES_SUIVIS: 'String', // <--  nom du programme
    ANNEE_SUIVIS: 'Date',
    RESULT_SUIVIS: 'String' ,// ← ex: [2005-2007]
    SOURCE: 'String',
    BASE_OROM: 'null',
    EFF_NAT: 'Number', // calcul à écrire R_D_RESULT*R_D_NAT/100
    EFF_REG: 'Number', // R_D_RESULT*R_D_REG/100
    EFF_DEP: 'Number', // R_D_RESULT*R_D_DEP/100
    STATUT_MONDE: 'String', // FromExternalTable(REF_TAXEREF_STATUT).TYPE_STATUS: Filtre: ‘liste rouge mondiale’ 
    STATUT_EU: 'String', // FromExternalTable(REF_TAXEREF_STATUT).TYPE_STATUS: Filtre: ‘liste rouge européenne’
    STATUT_FR: 'String', // FromExternalTable(REF_TAXEREF_STATUT).TYPE_STATUS: Filtre: ‘liste rouge nationale’
    STATUT_BZH: 'String', // FromExternalTable(REF_TAXEREF_STATUT).TYPE_STATUS: Filtre: ‘liste rouge régionale’: => LB_ADM_TR: Filtre: ‘Bretagne’
  },
  AUTRES_SP_AVIF: {
    DESCRIPTION: 'String',
    DATE: 'Date',
    ANNEE: 'String',
    NOM_SCI: 'String',
    NOM_VERN: 'String',
    NICHEUR: 'Boolean',
    RESULT: 'String', // ← ex: [2005-2007]
    SOURCE: 'String',
    STATUT_MONDE: 'String', 
    STATUT_EU: 'String', 
    STATUT_FR: 'String', 
    STATUT_BZH: 'String',
    SOURCE: 'String',
  },
  DONNEES_WETLAND: {
    DATE: 'Date',
    NOM_SCI: 'String',
    NOM_VERN: 'String',
    EFF_NAT: 'String',
    EFF_REG: 'String',
    EFF_DEP: 'String',
    EVOL_5: 'String',
    EVOL_10: 'String',
    EVOL_15: 'String',
    EVOL_20: 'String',
    STATUT_MONDE: 'String', 
    STATUT_EU: 'String', 
    STATUT_FR: 'String', 
    STATUT_BZH: 'String',
  },
  WETLAND: {
    DATE: 'Date',  
    ANNEE: 'String',
    NOM_SCI: 'String',
    NOM_VERN: 'String',
    EFF_WETLAND_MIN: 'String', // [min, max]
    EFF_WETLAND_MAX: "String",
    SOURCE: 'String',
    EFF_NAT: 'String', //FromTable(DONNEES_WETLAND).EFF_NAT,
    EFF_REG: 'String', //FromTable(DONNEES_WETLAND).EFF_REG,
    EFF_DEP: 'String', //FromTable(DONNEES_WETLAND).EFF_DEP,
    EVOL_20: 'String', //FromTable(DONNEES_WETLAND).EVOL_20,
    EVOL_15: 'String', //FromTable(DONNEES_WETLAND).EVOL_15,
    EVOL_10: 'String', //FromTable(DONNEES_WETLAND).EVOL_10,
    EVOL_5: 'String', //FromTable(DONNEES_WETLAND).EVOL_5,
    /*EFF_NAT: 'String', // calcul à écrire = EFF_WETLAND*EFF_NAT/100
    EFF_REG: 'String', // R_D_RESULT*R_D_REG/100
    EFF_DEP: 'String' */// R_D_RESULT*R_D_DEP/100
  },
  FAUNE: {
    DESCRIPTION: 'String',
    NOM_SCI: 'String',
    NOM_VERN: 'String',
    DATE: 'Date',
    OBSERVATEUR: 'String',
    SOURCE: 'String' /* Base de données */,
    PROT_NAT: 'String',
    LR_NAT: 'String',
    LR_REG: 'String',
    DIR_HAB: 'String'
  },
  INVERTEBRE: {
    DESCRIPTION: 'String',
    SP_SCI: 'String',
    SP_VERN: 'String',
    DATE: 'Date',
    OBSERVATEUR: 'String',
    SOURCE: 'String' /* Base de données */,
    TAXREF: 'String'
  },
  REPTILE: {
    DESCRIPTION: 'String',
    SP_SCI: 'String',
    SP_VERN: 'String',
    DATE: 'Date',
    OBSERVATEUR: 'String',
    SOURCE: 'String' /* Base de données */,
    TAXREF: 'String'
  },
  MAMMIFERE: {
    DESCRIPTION: 'String',
    SP_SCI: 'String',
    SP_VERN: 'String',
    DATE: 'Date',
    OBSERVATEUR: 'String',
    SOURCE: 'String' /* Base de données */,
    TAXREF: 'String'
  },
  FLORE: {
    DESCRIPTION: 'String',
    NOM_VERN: 'String',
    NOM_SCI: 'String',
    DATE: 'String',
    OBSERVATEUR: 'String',
    PROT_NAT: 'String',
    LR_NAT: 'String',
    LR_MASSIF_ARMO: 'String',
    DIR_HAB: 'String'
  // VOIR BDD CBNB
  },
  HABITAT: {
    DESCRIPTION: 'String',
    CODE_EUNIS: 'String',
    CODE_EU: 'String',
    NOM_HABITAT: 'String'
  },
  ARCHEO_HISTORIQUE: {
    DESCRIPTION: 'String',
    INVENTAIRE_ARCHEO: ['String' ], // ← Liste de découvertes
    BATI_HISTO: ['Boolean'],
    MONU_HISTO: ['String'] // ← Quel monument historique
  },
  GEOMORPHOLOGIE_GEOLOGIE: {
    DESCRIPTION: 'String',
    FORM_INTERET: ['String'],
    INTERET_GEOL: 'Boolean'
  },
  ESPECES_INTRODUITES: {
    NOM_VERN_FAUNE: 'String',
    NOM_SCI_FAUNE: 'String',
    DATE_OBS_FAUNE: 'String',
    OBS_FAUNE: 'String',
    NOM_VERN_FLORE: 'String',
    NOM_SCI_FLORE: 'String',
    DATE_OBS_FLORE: 'String',
    OBS_FLORE: 'String',
    /** REF BDD CDL **/
  },
  PERTURBATION_ANTHROPIQUE: {
    /** REF TABBLE CDL **/
    DESCRIPTION: 'String',
    FREQ_HUMAINE: ['String'], // 
    ACTEUR_LOCAUX: ['String'],
    DERANGEMENT: ['String'], // 
    DEBARQUEMENT: 'String', //
    CAPACITES_D_ACCES: 'String'
  },
  GESTION: {
    TYPE_D_ACCORD: 'String',
    SURVEILLANCE_PRESENCE: 'String',
    PDG: 'String',
    PERIODE: [ 'Date', 'Date' ],
    TYPE_GESTION: 'String',
    ACTION_GESTION_ANNUEL: 'String',
    DUREE_ACTION: 'String'
  },
};